
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import MahiyetSecForm from '@/components/eicrapro/MahiyetSecForm.vue';
import TakipHazirlaVekaletEkleDialog from '@/components/eicrapro/TakipHazirlaVekaletEkleDialog.vue';
import TakipHazirlaDayanakEkleForm from '@/components/eicrapro/TakipHazirlaDayanakEkleForm.vue';
import TakipHazirlaAlacakKalemiBelgeEkleForm from '@/components/eicrapro/TakipHazirlaAlacakKalemiBelgeEkleForm.vue';
import DayanakList from '@/components/eicrapro/DayanakList.vue';
import UyapIlamBilgileriForm from '@/components/eicrapro/UyapIlamBilgileriForm.vue';
import LedgerSection from '@/components/eicrapro/shared/LedgerSection.vue';
import NewFormDialog from '@/components/dialogs/NewFormDialog.vue';
import FormDialog from '@/components/dialogs/FormDialog.vue';
import TarafColumn from './columns/TarafColumn.vue';
import ActionsColumn from './columns/ActionsColumn.vue';
import PreviewColumn from './columns/PreviewColumn.vue';
import TakipDetailDialog from './dialogs/TakipDetailDialog.vue';
import TakipHazirlaProgressBar from './TakipHazirlaProgressBar.vue';
import {DosyaFormDataInterface} from '@/plugins/uyap-plugin/takip_ac/DosyaFormDataInterface';
import TarafKisi from '@/plugins/uyap-plugin/takip_ac/parser/TarafKisi';
import TarafKurum from '@/plugins/uyap-plugin/takip_ac/parser/TarafKurum';
import JSZip from 'jszip';
import {saveAs} from 'file-saver';
import {ActionType} from "@/components/forms/form-wizard/eicrapro/TakipHazirlaFormBetaWizard.vue";
import {TakipAcStatusEnum} from "@/plugins/uyap-plugin/takip_ac/parser/TakipAcStatusEnum";
import UyapTakipAc from "@/plugins/uyap-plugin/takip_ac/UyapTakipAc";
import {downloadTakipHazirlaExcel} from '@/components/forms/form-wizard/eicrapro/takip-hazirla/utils/takipHazirlaExcelExport';

@Component({
  components: {
    MahiyetSecForm,
    TakipHazirlaVekaletEkleDialog,
    TakipHazirlaDayanakEkleForm,
    TakipHazirlaAlacakKalemiBelgeEkleForm,
    DayanakList,
    UyapIlamBilgileriForm,
    LedgerSection,
    NewFormDialog,
    FormDialog,
    TarafColumn,
    ActionsColumn,
    PreviewColumn,
    TakipDetailDialog,
    TakipHazirlaProgressBar,
  },
})
export default class TakipHazirlaniyor extends Vue {
  @Prop({required: true}) readonly localValue!: DosyaFormDataInterface;
  @Prop({default: false}) readonly isSubmitting!: boolean;
  showDetailDialog = false;
  selectedItem: UyapTakipAc | null = null;

  // Confirmation dialog state
  isConfirmationMode = false;
  confirmationActionType: ActionType | null = null;

  takipAcStatusEnum = TakipAcStatusEnum;

  // Toplu İşlemler Dialog State
  mahiyetDialog = false;
  vekaletDialog = false;
  dayanakDialog = false;
  dayanakFormData: Array<{ name: string; data: string; mimeType: string }> = [];
  isDownloadingMakbuzlar = false;

  duplicateSecimOnayDialog = false;
  duplicateSecimPendingItem: UyapTakipAc | null = null;

  // Taraf seçim state'i - { [refId: string]: boolean }
  tarafSelectionState: Record<string, boolean> = {};

  // Status mapping - Single source of truth (DRY principle)
  private static readonly STATUS_CONFIG: Record<TakipAcStatusEnum, {
    icon: string;
    color: string;
    text: string;
  }> = {
    [TakipAcStatusEnum.QUERY_PENDING]: {
      icon: 'mdi-help-circle',
      color: 'orange',
      text: 'Beklemede'
    },
    [TakipAcStatusEnum.QUERY_FAIL]: {
      icon: 'mdi-alert-circle',
      color: 'red',
      text: 'Sorgu Hatası'
    },
    [TakipAcStatusEnum.QUERY_SUCCESS]: {
      icon: 'mdi-bookmark-check',
      color: 'blue',
      text: 'Sorgulama Başarılı'
    },
    [TakipAcStatusEnum.PREPARE_PROCESSING]: {
      icon: 'mdi-progress-clock',
      color: 'grey',
      text: 'İşleniyor'
    },
    [TakipAcStatusEnum.PREPARE_FAILED]: {
      icon: 'mdi-close-circle',
      color: 'red',
      text: 'Hazırlama Hatası'
    },
    [TakipAcStatusEnum.PREPARE_SUCCESS]: {
      icon: 'mdi-check-circle',
      color: 'green',
      text: 'Hazırlandı'
    },
    [TakipAcStatusEnum.OPEN_READY]: {
      icon: 'mdi-check-circle',
      color: 'blue',
      text: 'Hazır'
    },
    [TakipAcStatusEnum.OPEN_PROCESSING]: {
      icon: 'mdi-progress-clock',
      color: 'grey',
      text: 'İşleniyor'
    },
    [TakipAcStatusEnum.OPEN_FAIL]: {
      icon: 'mdi-close-circle',
      color: 'red',
      text: 'Tevzi Hatası'
    },
    [TakipAcStatusEnum.OPEN_SUCCESS]: {
      icon: 'mdi-check-all',
      color: 'green',
      text: 'Başarılı'
    },
    [TakipAcStatusEnum.TAHSILAT_FAIL]: {
      icon: 'mdi-close-circle',
      color: 'red',
      text: 'Tahsilat Hatası'
    },
    [TakipAcStatusEnum.DUPLICATE_WARNING]: {
      icon: 'mdi-alert',
      color: 'orange darken-2',
      text: 'UYAP\'ta Eşleşen Takip Bulundu'
    }
  };

  // Table headers - Stratejik genişlik yönetimi
  tableHeaders = [
    {text: '#', value: 'tempId', width: '40px', align: 'center', sortable: false},
    {text: 'Alacaklı (XML / Sorgulanan)', value: 'alacaklilar', align: 'left', sortable: false},
    {text: 'Borçlu (XML / Sorgulanan)', value: 'borclular', align: 'left', sortable: false},
    {
      text: 'Takibe Esas Tutar',
      value: 'toplamTakibeEsasMiktar',
      align: 'left',
      sortable: false,
      class: 'amount-col',
      cellClass: 'amount-col',
    },
    {text: 'Esas No', value: 'esasNo', align: 'left', sortable: false},
    {text: 'Birim', value: 'birim', align: 'left', sortable: false},
    {text: 'Durum', value: 'status_badge', align: 'left', sortable: false},
    {text: 'İşlemler', value: 'actions', align: 'left', sortable: false},
    {text: 'Ön İzleme', value: 'preview', align: 'left', sortable: false},
  ];

  get onFly(): boolean {
    return this.$store.getters['takipHazirla/isSubmitting'] || false;
  }

  get durumAciklamasi() {
    return this.$store.getters['takipHazirla/durumAciklamasi'];
  }

  get isRunQuery() {
    return this.$store.getters['takipHazirla/isRunQuery'];
  }

  get sorgulanmaDurumu() {
    return this.$store.getters['takipHazirla/sorgulanmaDurumu'];
  }

  get dosyalar(): UyapTakipAc[] {
    return this.$store.getters['takipHazirla/dosyalar'];
  }

  get secilenDosyalar(): UyapTakipAc[] {
    return this.$store.getters['takipHazirla/secilenDosyalar'];
  }

  get selectableDosyalar(): UyapTakipAc[] {
    return this.dosyalar.filter(dosya =>
        dosya.status !== TakipAcStatusEnum.OPEN_SUCCESS
        && dosya.status !== TakipAcStatusEnum.QUERY_FAIL
        && dosya.status !== TakipAcStatusEnum.DUPLICATE_WARNING
    );
  }

  get dosyaValidasyonHatalari(): Array<{ tempId: number, message: string }> {
    const hatalar = this.$store.getters['takipHazirla/dosyaValidasyonHatalari'];
    return Array.isArray(hatalar) && hatalar.length > 0 ? hatalar : [];
  }

  get isParsing(): boolean {
    return this.$store.getters['takipHazirla/isParsing'] || false;
  }

  get mahiyetler() {
    return this.$store.getters['takipHazirla/mahiyetler'] || [];
  }

  get mahiyetCheck(): boolean {
    return this.$store.getters['takipHazirla/mahiyetCheck'];
  }

  get ilamCheck(): boolean {
    return this.$store.getters['takipHazirla/ilamCheck'];
  }

  get vekaletCheck(): number[] {
    return this.$store.getters['takipHazirla/vekaletCheck'];
  }

  get tarafHatalari(): string[] {
    return this.$store.getters['takipHazirla/tarafHatalari'];
  }

  get alacakliProblemVarMi(): boolean {
    return this.$store.getters['takipHazirla/alacakliProblemVarMi'];
  }

  get uyapEslesenTakipCount(): number {
    const uyapDosyalar: UyapTakipAc[] = this.$store.getters['takipHazirla/dosyalar'] || [];
    return uyapDosyalar.filter(d => d.status === TakipAcStatusEnum.DUPLICATE_WARNING).length;
  }

  get hasTamamlanmisDosya(): boolean {
    const uyapDosyalar: UyapTakipAc[] = this.$store.getters['takipHazirla/dosyalar'] || [];
    return uyapDosyalar.some((dosya: any) => (dosya.status === TakipAcStatusEnum.OPEN_SUCCESS) && dosya.imzaliUdf);
  }

  get showExcelExport(): boolean {
    return this.dosyalar.some(d => d.status === TakipAcStatusEnum.OPEN_SUCCESS || d.status === TakipAcStatusEnum.OPEN_FAIL);
  }

  openDayanakDialog() {
    this.dayanakFormData = [];
    this.dayanakDialog = true;
  }

  exportExcelReport(): void {
    const exportList = this.dosyalar.filter(d => d.status === TakipAcStatusEnum.OPEN_SUCCESS || d.status === TakipAcStatusEnum.OPEN_FAIL);
    try {
      downloadTakipHazirlaExcel({
        dosyalar: exportList,
      });
    } catch (error) {
      console.error('Excel export:', error);
      this.$toast.error('Excel oluşturulurken hata oluştu.');
    }
  }

  async handleMahiyetSuccess(mahiyet: Array<{ mahiyetTuru: string; value: string | number }>) {
    await this.$store.dispatch('takipHazirla/updateMahiyet', mahiyet);
    this.mahiyetDialog = false;
    // Vuex action commit ettiği için dosyalar computed property otomatik güncellenecek
  }

  async handleVekaletSuccess(vekalet: { id: number; [key: string]: unknown }) {
    await this.$store.dispatch('takipHazirla/addVekaletToAll', vekalet);
    this.vekaletDialog = false;
    // Vuex action commit ettiği için dosyalar computed property otomatik güncellenecek
  }

  async handleDayanakSuccess(dayanaklar: Array<{ name: string; data: string; mimeType: string }>) {
    await this.$store.dispatch('takipHazirla/addDayanakToAll', dayanaklar);
    this.dayanakDialog = false;
    // Vuex action commit ettiği için dosyalar computed property otomatik güncellenecek
  }

  openDetailDialog(item: UyapTakipAc) {
    this.selectedItem = item;
    this.isConfirmationMode = false;
    this.showDetailDialog = true;
  }

  closeDetailDialog() {
    this.showDetailDialog = false;
    this.selectedItem = null;
    this.isConfirmationMode = false;
    this.confirmationActionType = null;
  }

  @Watch('duplicateSecimOnayDialog')
  onDuplicateSecimDialogToggle(open: boolean) {
    if (!open) {
      this.duplicateSecimPendingItem = null;
    }
  }

  @Watch('dosyalar', {deep: false})
  onDosyalarChange(newDosyalar: UyapTakipAc[]) {
    // Yeni dosyalar geldiğinde, mevcut olmayan refId'leri temizle
    const validRefIds = new Set<string>();
    newDosyalar.forEach(dosya => {
      dosya.parsedFile?.tarafList?.forEach(taraf => {
        validRefIds.add(taraf.refId);
        // Yeni taraflar için default değer
        if (!(taraf.refId in this.tarafSelectionState)) {
          this.$set(this.tarafSelectionState, taraf.refId, taraf.takipeDahilEt);
        }
      });
    });

    // Artık mevcut olmayan tarafları state'ten temizle
    Object.keys(this.tarafSelectionState).forEach(refId => {
      if (!validRefIds.has(refId)) {
        this.$delete(this.tarafSelectionState, refId);
      }
    });
  }

  openConfirmationDialog(item: UyapTakipAc, actionType: ActionType) {
    this.selectedItem = item;
    this.isConfirmationMode = true;
    this.confirmationActionType = actionType;
    this.showDetailDialog = true;
  }

  handleConfirmationApprove() {
    this.$emit('confirmation-approved', this.confirmationActionType);
    this.closeDetailDialog();
  }

  handleConfirmationCancel() {
    this.$emit('confirmation-cancelled');
    this.closeDetailDialog();
  }

  tumDosyalariSec() {
    const selectableDosyalar = this.selectableDosyalar;
    const currentValue = this.$store.getters['takipHazirla/secilenDosyalar'];

    if (currentValue.length === selectableDosyalar.length) {
      this.$store.commit('takipHazirla/SET_SECILEN_DOSYALAR', []);
    } else {
      this.$store.commit('takipHazirla/SET_SECILEN_DOSYALAR', selectableDosyalar);
    }
  }

  handleCheckboxChange(
      item: UyapTakipAc,
      checked: boolean,
      _selectFn: (value: boolean) => void
  ) {
    const currentValue: UyapTakipAc[] = this.$store.getters['takipHazirla/secilenDosyalar'];

    const exists = currentValue.some(d => d.tempId === item.tempId)

    // State zaten doğruysa hiçbir şey yapma
    if (checked === exists) return

    if (!checked) {
      const selectedIds = new Set(
          currentValue.filter(d => d.tempId !== item.tempId).map(d => d.tempId)
      );
      const newValue = this.dosyalar.filter(d => selectedIds.has(d.tempId));
      this.$store.commit('takipHazirla/SET_SECILEN_DOSYALAR', newValue);
      return;
    }

    if (
        item.status === TakipAcStatusEnum.DUPLICATE_WARNING
        && item.eslesenUyapDosyalar?.length
    ) {
      this.duplicateSecimPendingItem = item;
      this.duplicateSecimOnayDialog = true;
      return;
    }

    const selectedIds = new Set([
      ...currentValue.map(d => d.tempId),
      item.tempId,
    ]);
    const newValue = this.dosyalar.filter(d => selectedIds.has(d.tempId));
    this.$store.commit('takipHazirla/SET_SECILEN_DOSYALAR', newValue);
  }

  onDuplicateSecimEvet() {
    const item = this.duplicateSecimPendingItem;
    if (!item) {
      this.duplicateSecimOnayDialog = false;
      return;
    }
    item.eslesenUyapSecimOnayZamani = new Date().toLocaleString('tr-TR', {timeZone: 'Europe/Istanbul'});
    const currentValue: UyapTakipAc[] = this.$store.getters['takipHazirla/secilenDosyalar'];
    const selectedIds = new Set(currentValue.map(d => d.tempId));
    selectedIds.add(item.tempId);
    const newValue = this.dosyalar.filter(d => selectedIds.has(d.tempId));
    this.$store.commit('takipHazirla/SET_SECILEN_DOSYALAR', newValue);
    this.duplicateSecimOnayDialog = false;
  }

  onDuplicateSecimHayir() {
    this.duplicateSecimOnayDialog = false;
  }

  getStatusIcon(status: TakipAcStatusEnum): string {
    return TakipHazirlaniyor.STATUS_CONFIG[status]?.icon || 'mdi-help-circle';
  }

  getStatusColor(status: TakipAcStatusEnum): string {
    return TakipHazirlaniyor.STATUS_CONFIG[status]?.color || 'grey';
  }

  isErrorStatus(status: TakipAcStatusEnum): boolean {
    return status === TakipAcStatusEnum.OPEN_FAIL || status === TakipAcStatusEnum.QUERY_FAIL;
  }

  isProcessingStatus(status: TakipAcStatusEnum): boolean {
    return status === TakipAcStatusEnum.OPEN_PROCESSING || status === TakipAcStatusEnum.PREPARE_PROCESSING;
  }

  isTimeoutError(dosya: UyapTakipAc): boolean {
    return dosya.messages?.some(m => /zaman aşımı/i.test(m.message)) || false;
  }

  getStatusText(dosya: UyapTakipAc): string {
    const config = TakipHazirlaniyor.STATUS_CONFIG[dosya.status];
    if (!config) return 'Bilinmiyor';

    // Optional chaining ile son mesajı al
    const lastMessage = dosya.messages?.[dosya.messages.length - 1]?.message || '';

    if (dosya.status === TakipAcStatusEnum.OPEN_FAIL && this.isTimeoutError(dosya)) {
      return `Zaman Aşımı: ${lastMessage}`;
    }

    // Hata durumlarında mesaj detayı ekle
    if ([TakipAcStatusEnum.OPEN_FAIL, TakipAcStatusEnum.QUERY_FAIL].includes(dosya.status)) {
      return `${config.text}: ${lastMessage}`;
    }

    if (dosya.status === TakipAcStatusEnum.DUPLICATE_WARNING && dosya.eslesenUyapDosyalar?.length) {
      const dosyaListesi = dosya.eslesenUyapDosyalar
        .map(d => `${d.dosyaNo} - ${d.birimAdi} (${d.acilisTarihi})`)
        .join('\n');
      return `${config.text}:\n${dosyaListesi}`;
    }

    return config.text;
  }

  getAlacaklilar(item: UyapTakipAc): Array<TarafKisi | TarafKurum> {
    return item.parsedFile?.tarafList?.filter(t => t?.isAlacakli?.()) || [];
  }

  getBorclular(item: UyapTakipAc): Array<TarafKisi | TarafKurum> {
    return item.parsedFile?.tarafList?.filter(t => t?.isBorclu?.()) || [];
  }

  async downloadImzaliUdfler() {
    try {
      const uyapDosyalar: UyapTakipAc[] = this.$store.getters['takipHazirla/dosyalar'] || [];
      const tamamlanmisDosyalar = uyapDosyalar.filter((dosya: any) => {
        return dosya.status === TakipAcStatusEnum.OPEN_SUCCESS && dosya.imzaliUdf;
      });
      if (tamamlanmisDosyalar.length === 0) {
        this.$toast.warning('İndirilecek imzalı UDF dosyası bulunamadı.');
        return;
      }

      const zip = new JSZip();
      const folder = zip.folder('imzali-udfler');
      if (!folder) {
        throw new Error('ZIP klasörü oluşturulamadı');
      }

      tamamlanmisDosyalar.forEach((dosya: any, index: number) => {
        try {
          const tempId = dosya.tempId || (index + 1);
          const fileName = `Dosya-${tempId}_imzali.udf`;
          folder.file(fileName, dosya.imzaliUdf);
        } catch (error) {
          console.error(`Dosya ${dosya.tempId} eklenirken hata:`, error);
        }
      });

      this.$toast.info('ZIP dosyası hazırlanıyor...');
      const content = await zip.generateAsync({type: 'blob'});
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
      const zipFileName = `imzali-udfler_${timestamp}.zip`;
      saveAs(content, zipFileName);
      this.$toast.success(`${tamamlanmisDosyalar.length} dosya ZIP olarak indirildi.`);
    } catch (error) {
      console.error('İmzalı UDF indirme hatası:', error);
      this.$toast.error('İmzalı UDF dosyaları indirilirken hata oluştu.');
    }
  }

  async downloadMakbuzlar() {
    if (this.isDownloadingMakbuzlar) return;
    this.isDownloadingMakbuzlar = true;
    try {
      const uyapDosyalar: UyapTakipAc[] = this.$store.getters['takipHazirla/dosyalar'] || [];
      const tamamlanmisDosyalar = uyapDosyalar.filter((dosya: any) => {
        return dosya.status === TakipAcStatusEnum.OPEN_SUCCESS;
      });

      if (tamamlanmisDosyalar.length === 0) {
        this.$toast.warning('İndirilecek makbuz bulunamadı.');
        return;
      }

      const zip = new JSZip();
      const tahsilHarciFolder = zip.folder('tahsil-harci');
      const tahsilatFolder = zip.folder('tahsilat');

      if (!tahsilHarciFolder || !tahsilatFolder) {
        throw new Error('ZIP klasörleri oluşturulamadı');
      }

      let successCount = 0;
      let partialFailCount = 0;

      for (const dosya of tamamlanmisDosyalar) {
        try {
          const tempId = dosya.tempId || (successCount + 1);
          let dosyaBasarili = false;

          try {
            const tahsilHarciBlob = await dosya.getTahsilHarciMakbuzuBlob();
            tahsilHarciFolder.file(`Dosya-${tempId}_TahsilHarci.pdf`, tahsilHarciBlob);
            dosyaBasarili = true;
          } catch (e) {
            console.warn(`Dosya ${tempId} Tahsil Harcı Makbuzu indirilemedi:`, e);
          }

          try {
            const tahsilatBlob = await dosya.getTahsilatMakbuzuBlob();
            tahsilatFolder.file(`Dosya-${tempId}_Tahsilat.pdf`, tahsilatBlob);
            dosyaBasarili = true;
          } catch (e) {
            console.warn(`Dosya ${tempId} Tahsilat Makbuzu indirilemedi:`, e);
          }

          if (dosyaBasarili) {
            successCount++;
          } else {
            partialFailCount++;
          }
        } catch (error) {
          console.error(`Dosya ${dosya.tempId} işlenirken hata:`, error);
          partialFailCount++;
        }
      }

      if (successCount === 0) {
        this.$toast.error('Hiçbir makbuz indirilemedi.');
        return;
      }

      const content = await zip.generateAsync({type: 'blob'});
      const timestamp = new Date()
          .toISOString()
          .replace(/[:.]/g, '-')
          .slice(0, -5);
      saveAs(content, `makbuzlar_${timestamp}.zip`);

      const mesaj = partialFailCount > 0
          ? `${successCount} dosya indirildi, ${partialFailCount} dosyada makbuz eksik.`
          : `${successCount} dosyanın makbuzları ZIP olarak indirildi.`;
      this.$toast.success(mesaj);
    } catch (error) {
      console.error('Makbuz indirme hatası:', error);
      this.$toast.error('Makbuzlar indirilirken hata oluştu.');
    } finally {
      this.isDownloadingMakbuzlar = false;
    }
  }
}
